import { getRaw, postRaw } from 'services/api';
import { omit } from 'lodash';

export const CAMPAIGNS_URL = '/campaigns.json';
export const REPORTS_BASE_URL = '/i/reports';
export const REPORTS_URL = '/i/reports.json';
export const REPORTS_UPSERT_URL = '/i/reports/upsert';
export const REPORTS_DELETE_URL = '/i/reports/delete';
export const REPORT_DATA_URL = '/i/reports/previewDateTimeViewData';
export const REPORT_SUMMARY_URL = '/i/reports/previewCampaignViewData';
export const METRICS_URL = '/i/highLevelMetrics';
export const WORKFLOWS_URL = '/i/workflows';
export const EXPORT_REPORT_AS_CSV_URL = '/i/reports/export/report.csv';

export function getTestData(page = 1, pageSize = 10, orderBy = 'id', sorting = 'desc') {
  return getRaw(CAMPAIGNS_URL, {
    params: {
      page,
      pageSize,
      orderBy,
      sorting,
    },
  });
}

function transformSortingParams(params) {
  return { ...params, sorting: params.sorting === 'ascending' ? 'asc' : 'desc' };
}

function transformPageSizeParams(params) {
  return { ...params, count: params.pageSize };
}

function transformOrderByParams(params) {
  const orderByParamMap = {
    id: 'ById',
    name: 'ByName',
    createdAt: 'ByCreatedAt',
    updatedAt: 'ByUpdatedAt',
    creatorUserId: 'ByCreatedBy',
    rangeStart: 'ByRangeStart',
    rangeEnd: 'ByRangeEnd',
  };
  return { ...params, orderBy: orderByParamMap[params.orderBy] };
}

function transformFilterParams(params) {
  return { ...omit(params, 'filter'), query: params.filter };
}

export function getPaginatedReports(params) {
  return getRaw(REPORTS_URL, {
    params: transformFilterParams(transformOrderByParams(params)),
  });
}

export function upsert(params) {
  return postRaw(REPORTS_UPSERT_URL, params);
}

export function deleteReport(ids /*: number[] */) {
  return postRaw(REPORTS_DELETE_URL, { ids });
}

export function saveReport(report) {
  return postRaw(REPORTS_UPSERT_URL, report);
}

export function getReportById(id) {
  return getRaw(`${REPORTS_BASE_URL}/${id}`);
}

export function getCampaigns(params) {
  return getRaw(CAMPAIGNS_URL, {
    params: transformFilterParams(transformSortingParams(params)),
  });
}

export function getReportData(report) {
  return postRaw(REPORT_DATA_URL, report);
}

export function getReportSummaryData(report) {
  return postRaw(REPORT_SUMMARY_URL, report);
}

export function getMetrics() {
  return getRaw(METRICS_URL);
}

export function getWorkflows(params) {
  return getRaw(WORKFLOWS_URL, {
    params: transformPageSizeParams(transformSortingParams(params)),
  });
}

export function exportReportDataAsCsv(reportId /*: number */, timeZone /*: string */) {
  return getRaw(`${EXPORT_REPORT_AS_CSV_URL}?reportId=${reportId}&timezone=${timeZone}`);
}
